import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { theming } from 'styles/utils';
import { TipOrientation, TipPopoverProps } from './types';
const DOT_SIZE = '0.625rem';
const GAP = '0.5rem';
export const StyledPopover = /*#__PURE__*/styled("div")({
  name: "StyledPopover",
  class: "omponents__TipPopover__TipPopover_styles_ts-StyledPopover-s17izhux",
  vars: {
    "s17izhux-1": [
    // eslint-disable-next-line consistent-return
    ({
      orientation = TipOrientation.TopLeft
    }) => {
      // eslint-disable-next-line default-case
      switch (orientation) {
        case TipOrientation.TopLeft:
          return `translate(calc(-100% + ${DOT_SIZE} + ${GAP}), calc(-100% - ${GAP}))`;
        case TipOrientation.TopCenter:
          return `translate(-50%, calc(-100% - ${GAP}))`;
        case TipOrientation.TopRight:
          return `translate(-${GAP}, calc(-100% - ${GAP}))`;
        case TipOrientation.CenterLeft:
        case TipOrientation.LeftCenter:
          return `translate(calc(-100% - ${GAP}), -50%)`;
        case TipOrientation.Center:
          return 'translate(-50%, -50%)';
        case TipOrientation.CenterRight:
        case TipOrientation.RightCenter:
          return `translate(calc(${DOT_SIZE} + ${GAP}), -50%)`;
        case TipOrientation.BottomLeft:
          return `translate(calc(-100% + ${DOT_SIZE} + ${GAP}), calc(${DOT_SIZE} + ${GAP}))`;
        case TipOrientation.BottomCenter:
          return `translate(-50%, calc(${DOT_SIZE} + ${GAP}))`;
        case TipOrientation.BottomRight:
          return `translate(-${GAP}, calc(${DOT_SIZE} + ${GAP}))`;
        case TipOrientation.LeftTop:
          return `translate(calc(-100% - ${GAP}), -${GAP})`;
        case TipOrientation.LeftBottom:
          return `translate(calc(-100% - ${GAP}), calc(-100% + ${GAP} * 2))`;
        case TipOrientation.RightTop:
          return `translateX(calc(${GAP} * 2))`;
        case TipOrientation.RightBottom:
          return `translate(calc(${GAP} * 2), calc(-100% + ${GAP} * 2))`;
        // No `default` statement.
      }
    }]
  }
});
export const container = "omponents__TipPopover__TipPopover_styles_ts-container-c1gkgako";

require("./TipPopover.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TipPopover.styles.ts");